export enum ErrorType {
  error = 'error',
  paymentError = 'paymentError',
  maintenance = 'maintenance',
}
